import { defaultRtn, SortByType } from '../declareTypes';

/** 数组处理 */
const arrayHandle = async () => { };

/**
 * 寻找
 * @param arr 数组
 * @param findValue 寻找的值
 * @param options 选项
 * @returns 
 */
arrayHandle.find = (
    arr: Array<any>,
    findValue: any,
    options?: {
        /** 查询的对象数组中的名称，用@分割，例如：id@name@.... */
        queryNames?: string,
        /** 寻找的值是否必需等于数组的值 */
        isMustEqual?: boolean
    }) => {
    const rtn = defaultRtn<[]>();
    try {
        const { queryNames, isMustEqual } = options || {};
        /** 返回数据 */
        let res: any = [];
        for (let i = 0; i < arr.length; i++) {
            if (queryNames) {
                const queryArray = queryNames.split('@');
                for (let keyIdName of queryArray) {
                    if (keyIdName) {
                        const item = typeof keyIdName === 'undefined' ? arr[i] : arr[i][keyIdName];
                        if (item) {
                            if (isMustEqual === true) {
                                if (item === findValue) {
                                    res = res.concat(arr[i]);
                                    break;
                                }
                            } else {
                                if (item.includes(findValue) === true) {
                                    res = res.concat(arr[i]);
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        }
        rtn.data = res;
        rtn.success = true;
    }
    catch (error: any) {
        rtn.message = '错误！';
        if (error) {
            const { message } = error;
            rtn.message = `错误！${message}`;
        }
    }
    return rtn;
};

/**
 * 查找数组中匹配的数据
 * @param arr 数组
 * @param idValue 匹配id值
 * @param options 选项
 * @returns 返回找到第一个值的数据数组 [data-数据, index-索引]
 * @example const findItem = await arrayHandle.findValue(
 * currentCallerToday, 
 * callerId, 
 * { keyIdName: 'findId', 
 *   targetId: 'isAnswered' });
 */
arrayHandle.findValue = (arr: Array<any>, idValue: any,
    options?: {
        /** 关键id名称 */
        keyIdName?: string,
        /** 匹配id行的目标Id，如果存在，返回值，否则返回数组内容 */
        targetId?: string
    }
) => {
    const rtn = defaultRtn();
    try {
        let { keyIdName, targetId } = options || {};
        if (typeof arr !== 'undefined') {
            if (arr.length > 0) {
                /** 索引 */
                const index = arr.findIndex((item: any) => {
                    return (typeof keyIdName === 'undefined') ? item === idValue : item[keyIdName] === idValue;
                });
                /** 数据 */
                let data;
                if (index > -1) {
                    data = arr[index];
                    if (targetId) {
                        data = data[targetId];
                    }
                    rtn.success = true;
                    rtn.data = [data, index];
                } else {
                    rtn.message = '无法查找到数组中匹配的数据';
                }
            } else {
                rtn.message = '参数错误，数组长度为0';
            }
        }
        else {
            rtn.message = '参数错误，数组为空';
        }
    }
    catch (error: any) {
        rtn.message = '错误！';
        if (error) {
            const { message } = error;
            rtn.message = `错误！${message}`;
        }
    }
    return rtn;
};

/**
 * 删除数组中匹配的数据
 * @param arr 数组
 * @param idValue 匹配id值
 * @param options 选项
 * @returns 返回删除后的数组
 * @example arrayHandle.deleteValue(rows, 'xx', { keyIdName: 'id' })
 */
arrayHandle.deleteValue = (arr: Array<any>, idValue: any, options?: {
    /** 关键id名称 */
    keyIdName?: string,
}) => {
    const rtn = defaultRtn({
        success: true
    });
    try {
        if (typeof arr !== 'undefined') {
            let { keyIdName } = options || {};
            /** 索引 */
            const index = arr.findIndex((item: any) => {
                return typeof keyIdName !== 'undefined' ? item[keyIdName] : item === idValue;
            });
            if (index > -1) {
                //删除数组方法，不要用delete
                arr.splice(index, 1);
            }
            rtn.data = arr;
        } else {
            rtn.message = '数组为空';
        }
    }
    catch (error: any) {
        rtn.success = false;
        rtn.message = '错误！';
        if (error) {
            const { message } = error;
            rtn.message = `错误！${message}`;
        }
    }
    return rtn;
};

/**
 * 数组合并，先对旧数组替换为新数组数据，对新数组去重，然后再concat合并新数据
 * @param oldArray 旧数组对象
 * @param newArray 新数组对象
 * @param options 选项
 */
arrayHandle.merge = (oldArray: Array<any>, newArray: Array<any>,
    options?: {
        /** 去重关键id名称 */
        keyIdName?: string,
        /** 旧数组去重关键id名称(优先级高于keyIdName参数) */
        oldKeyIdName?: string,
        /** 新数组去重关键id名称(优先级高于keyIdName参数) */
        newKeyIdName?: string,
        /** 数据是否合并，true为合并，false为替换 */
        isMerge?: boolean,
        /** 数组头部插入 */
        isUnshift?: boolean
    }) => {
    const rtn = defaultRtn({
        success: true,
        data: oldArray
    })
    try {
        if (Array.isArray(oldArray) === true && Array.isArray(newArray) === true) {
            let { keyIdName, oldKeyIdName, newKeyIdName, isMerge, isUnshift } = options || {};
            oldKeyIdName = typeof oldKeyIdName !== 'undefined' ? oldKeyIdName : keyIdName;
            newKeyIdName = typeof newKeyIdName !== 'undefined' ? newKeyIdName : keyIdName;
            /**
             * newArray寻找
             * @param oldArrayItem oldArray内容
             * @returns 
             */
            const newArrayFindIndex = (oldArrayItem: any) => {
                const res = newArray.findIndex((item: any) => {
                    /** 新内容 */
                    const newItem = (typeof newKeyIdName === 'undefined') ? item : item[newKeyIdName];
                    /** 旧内容 */
                    const oldItem = (typeof oldKeyIdName === 'undefined') ? oldArrayItem : oldArrayItem[oldKeyIdName];
                    return (typeof newItem === 'object' ? JSON.stringify(newItem) : newItem) ===
                        (typeof oldItem === 'object' ? JSON.stringify(oldItem) : oldItem);
                });
                return res;
            };
            for (var i = 0; i < oldArray.length; i++) {
                /** 索引 */
                const index = newArrayFindIndex(oldArray[i]);
                if (index > -1) {
                    if (isMerge === true) {
                        oldArray[i] = { ...oldArray[i], ...newArray[index] };
                    } else {
                        //替换内容
                        oldArray[i] = newArray[index];
                    }
                    //删除
                    newArray.splice(index, 1);
                }
            }
            if (newArray.length > 0) {
                if (isUnshift === false) {
                    oldArray = oldArray.concat(newArray);
                }
                else {
                    oldArray.unshift(...newArray);
                }
            }
        }
        rtn.data = oldArray;
    }
    catch (error: any) {
        rtn.message = '错误！';
        if (error) {
            const { message } = error;
            rtn.message = `错误！${message}`;
        }
    }
    return rtn;
};

/**
 * 数组替换，根据替换数组的替换id及替换变量替换目标数组中的变量，根据需求再合并数组
 * @param arr 目标数组
 * @param replaceArray 替换数组
 * @param options 选项
 */
arrayHandle.replace = (arr: Array<any>, replaceArray: Array<any>,
    options?: {
        /** 替换id，默认：id */
        replaceIdName?: string,
        /** 替换变量 */
        replaceValue?: any,
        /** 找目标数组中的关键id，默认：id */
        keyIdName?: string,
        /** 是否合并数组，默认：true */
        isMerge?: boolean
    }) => {
    const rtn = defaultRtn({
        success: true,
        data: arr
    });
    try {
        if (Array.isArray(arr) === true && Array.isArray(replaceArray) === true) {
            let { replaceIdName = 'id', replaceValue, keyIdName = 'id', isMerge = true } = options || {};
            /**
             * replaceArray查找index
             * @param arrayItem array内容
             * @returns 
             */
            const replaceArrayFindIndex = (arrayItem: any) => {
                const res = replaceArray.findIndex((item: any) => {
                    return item[keyIdName] === arrayItem[keyIdName] && item[replaceIdName] === replaceValue;
                });
                return res;
            }
            for (var i = 0; i < arr.length; i++) {
                /** 索引 */
                const index = replaceArrayFindIndex(arr[i]);
                if (index > -1) {
                    //替换内容
                    arr[i] = replaceArray[index];
                    //删除replaceArray
                    replaceArray.splice(index, 1);
                }
            }
            if (isMerge === true) {
                arr = arr.concat(replaceArray);
            }
            rtn.data = arr;
        }
    }
    catch (error: any) {
        rtn.message = '错误！';
        if (error) {
            const { message } = error;
            rtn.message = `错误！${message}`;
        }
    }
    return rtn;
};

/**
 * 数组排序(递归法)
 * @param arr 数组
 * @param options 选项
 * @returns 
 */
arrayHandle.sort = (arr: Array<any>, options?: {
    /** 排序依据属性，如错误，则不会排序 */
    prop?: string,
    /** 排序模式，默认：DESC */
    sortBy?: SortByType
}) => {
    /** 返回值 */
    const rtn = defaultRtn();
    try {
        let { prop, sortBy = 'DESC' } = options || {};
        /** 数组 */
        let res = arr;
        // 没有元素或只有1个元素 无需排序
        if (arr.length > 1) {
            /** 第一个元素作为基准值 */
            let piv;
            if (typeof prop !== 'undefined') {
                piv = arr[0][prop];
            }
            else {
                piv = arr[0];
            }
            /** 左侧 < 基准值数组 */
            let Larr = [];
            /** 右侧 > 基准值数组 */
            let Rarr = [];
            for (let i = 1; i < arr.length; i++) {
                /** 比较值 */
                let comparePiv;
                if (typeof prop !== 'undefined') {
                    comparePiv = arr[i][prop];
                }
                else {
                    comparePiv = arr[i];
                }
                if (comparePiv < piv) {
                    Larr.push(arr[i]);
                } else {
                    Rarr.push(arr[i]);
                }
            }
            // 递归调用sort 结果返回新数组
            res = [...arrayHandle.sort(Rarr, { prop }).data, arr[0], ...arrayHandle.sort(Larr, { prop }).data];
            switch (sortBy) {
                case 'ASC':
                    //反转数组中元素的顺序：
                    res = res.reverse();
                    break;
            }
            rtn.success = true;
            rtn.data = res;
        }
    }
    catch (error: any) {
        rtn.message = '参数错误！';
        if (error) {
            const { message } = error;
            rtn.message = `参数错误！${message}`;
        }
    }
    return rtn;
};

/**
 * 数组截取
 * @param arr 数组
 * @param truncateLenght 截取长度
 * @param options 选项
 * @example let arr = ['a', 'b', 'c', 'd', 'e', 'f','g','h'];
 * arrayHandle.truncate(arr, 4) return 'a','b','c','d';
 * arrayHandle.truncate(arr, 4, { direction: true}) return 'e','f','g','h';
 */
arrayHandle.truncate = (arr: Array<any>,
    truncateLenght: number,
    options?: {
        /** 截取方向，是否截取右长度 */
        direction?: boolean
    }
) => {
    const rtn = defaultRtn();
    try {
        const { direction } = options || {};
        const len = arr.length;
        const i = len - truncateLenght;
        if (i > 0) {
            let tArray;
            if (direction === true) {
                tArray = arr.slice(i, len);
            }
            else {
                tArray = arr.slice(0);
                tArray.splice(truncateLenght, i);
            }
            rtn.data = tArray;
        }
        else {
            rtn.data = arr;
        }
        rtn.success = true;
    }
    catch (error: any) {
        rtn.message = '错误！';
        if (error) {
            const { message } = error;
            rtn.message = `错误！${message}`;
        }
    }
    return rtn;
};

/**
 * 数组重排序
 * @param arr 数组
 * @param index 数据中的索引
 * @param options 选项
 * @returns 
 */
arrayHandle.reorder = (
    arr: Array<any>,
    index: number,
    options?: {
        /** 排序是否放在最前 */
        prefix?: boolean
    }) => {
    const rtn = defaultRtn();
    try {
        /** 数组长度 */
        const len = arr.length;
        if (len > 0 || len > index) {
            const { prefix } = options || {};
            let newItem = arr[index];
            let tArray = arr.slice(0);
            tArray.splice(index, 1);
            if (prefix === true) {
                rtn.data = [newItem].concat(tArray);
            } else {
                rtn.data = tArray.concat(newItem);
            }
        } else {
            rtn.data = arr;
        }
        rtn.success = true;
    }
    catch (error: any) {
        rtn.message = '错误！';
        if (error) {
            const { message } = error;
            rtn.message = `错误！${message}`;
        }
    }
    return rtn;
};

/**
 * 比较两个数组是否相同
 * @param arr1 数组一
 * @param arr2 数组二
 * @param options 选项
 */
arrayHandle.comparison = async (arr1: Array<any>, arr2: Array<any>, options?: {
    /** 数组中的关键id，如果存在keyIdName，则使用数组[keyIdName]比较 */
    keyIdName?: string
}) => {
    /** 返回 */
    const rtn = defaultRtn();
    try {
        if (typeof arr1 === 'undefined') {
            rtn.message = 'arr1 is undefined;'
        }
        if (typeof arr2 === 'undefined') {
            rtn.message += 'arr2 is undefined;';
        }
        const { keyIdName } = options || {};
        for (const itemOne of arr1) {
            let k = itemOne;
            const oneComparison = await arr2.find(element => {
                if (typeof keyIdName !== 'undefined') {
                    if (typeof element !== 'undefined') {
                        element = element[keyIdName];
                    }
                    if (typeof itemOne !== 'undefined') {
                        k = itemOne[keyIdName];
                    }
                }
                return (typeof element === 'object' ? JSON.stringify(element) : element) ===
                    (typeof k === 'object' ? JSON.stringify(k) : k)
            });
            if (typeof oneComparison === 'undefined') {
                rtn.success = false;
                rtn.message += `arr2不包括arr1.${typeof k === 'object' ? JSON.stringify(k) : k}；`;
                break;
            }
            rtn.success = true;
        }
        if (rtn.success === true) {
            for (let itemTwo of arr2) {
                let k = itemTwo;
                const twoComparison = await arr1.find(element => {
                    if (typeof keyIdName !== 'undefined') {
                        if (typeof element !== 'undefined') {
                            element = element[keyIdName];
                        }
                        if (typeof itemTwo !== 'undefined') {
                            k = itemTwo[keyIdName];
                        }
                    }
                    return (typeof element === 'object' ? JSON.stringify(element) : element) ===
                        (typeof k === 'object' ? JSON.stringify(k) : k)
                });
                if (typeof twoComparison === 'undefined') {
                    rtn.success = false;
                    rtn.message += `arr1不包括arr2.${typeof k === 'object' ? JSON.stringify(k) : k}`;
                    break;
                }
                rtn.success = true;
            }
        }
    }
    catch (error: any) {
        rtn.message = '错误！';
        if (error) {
            const { message } = error;
            rtn.message = `错误！${message}`;
        }
    }
    return rtn;
};

/**
 * 数组选择属性输出
 * @param arr 数组
 * @param keys 属性集合
 * @example const result = pickProperties(arr, ['id', 'name']);
 * @returns 
 */
arrayHandle.pickProperties = <T, K extends keyof T>(arr: T[], keys: K[]): Pick<T, K>[] =>
    arr.map(item => keys.reduce((acc, key) => ({ ...acc, [key]: item[key] }), {} as Pick<T, K>));

/** 数组处理 */
export default arrayHandle;